import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { isIE } from 'react-device-detect';
import IEDialog from './IEDialog';
import * as S from './Layout.styles';

const MainContent = ({
  children,
  isGuidePage,
  isMemberBenefitPage,
  className,
}: {
  children: ReactNode;
  isGuidePage?: boolean;
  isMemberBenefitPage?: boolean;
  className?: string;
}) => {
  const mainContentRef = useRef<HTMLElement>(null);

  const [showIEDialog, setShowIEDialog] = useState(false);
  useEffect(() => {
    setShowIEDialog(isIE);
  }, []);

  const handleSkipToContent = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById('mainContent');
    if (!el) return;
    el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: false });
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const handleBlur = () => el.removeAttribute('tabindex');
    el.addEventListener('blur', handleBlur, { once: true });
  };

  return (
    <S.Content $isGuidePage={isGuidePage} $isMemberBenefitPage={isMemberBenefitPage} className={className}>
      <S.StyledSkipLink href="#mainContent" onClick={handleSkipToContent}>
        Gå til hovedinnhold
      </S.StyledSkipLink>
      {showIEDialog && <IEDialog />}
      <main ref={mainContentRef} id="mainContent">
        {children}
      </main>
    </S.Content>
  );
};

export default MainContent;
